import { Typography, useLocaleFormat } from '@eye-able/ui';
import type { PolicyResponse } from '@http/queries/useFetchPolicies';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export function getLatestPolicyScanAt(
  policies: PolicyResponse[] | undefined,
): string | null {
  return (policies ?? []).reduce<string | null>(
    (latest, policy) =>
      policy.lastScanAt &&
      (!latest || new Date(policy.lastScanAt) > new Date(latest))
        ? policy.lastScanAt
        : latest,
    null,
  );
}

export function LastPolicyScan({ lastScanAt }: { lastScanAt: string | null }) {
  const { formatDate } = useLocaleFormat();
  const { t } = useInlineTranslation();

  if (!lastScanAt) return null;

  const scanDate = new Date(lastScanAt);

  return (
    <div>
      <Typography tag='span' variant='body-s' className='eye:text-grey-120'>
        {t('lastPolicyScan')}
      </Typography>{' '}
      <Typography
        tag='time'
        variant='body-s-highlight'
        dateTime={scanDate.toISOString()}
      >
        {formatDate(scanDate, 'Pp')}
      </Typography>
    </div>
  );
}
